<div class="main-container" [class.lg-view]="!isInline" [class.inline-contacts]="isInline" *ngIf="!isLoading">
	<h3>{{ pageTitle || 'Contacts' }}</h3>

	<div class="contacts-list">
		<p class="empty-message-container" *ngIf="!contacts?.length">{{ noContactsMessage || 'There are no available contacts!' }}</p>

		<div class="contact-container" *ngFor="let contact of contacts">
			<div class="contact-name contact-name-inline">
				<span class="contact-type" *ngIf="contact.contactType === ContactType.Assignee">A</span>
				<span class="contact-type" *ngIf="contact.contactType === ContactType.Customer">C</span>
				<span class="contact-type" *ngIf="contact.contactType === ContactType.Vendor">V</span>
				<span class="contact-type" *ngIf="contact.contactType === ContactType.BoardMember">B</span>
				<span>{{ contact.lastName }}, {{ contact.firstName }}</span>
			</div>
			<div class="contact-details">
				<span class="contact-company">{{ contact.companyName }}</span>
				<span class="contact-email">{{ contact.emailAddress }}</span>
				<span class="contact-phone">{{ contact.phoneNumber }}</span>
			</div>
		</div>
	</div>

</div>

<div class="actions-container md-view" *ngIf="!isLoading && !isInline">
	<ng-container *ngIf="customerPreferences == null || (!customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled)">
		<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'..'"></action-button>
	</ng-container>

	<div class="actions-placeholder-message" *ngIf="customerPreferences && (customerPreferences.preferences.isJobAutoSkipped || customerPreferences.preferences.isNotificationDisabled)">
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
		<span
			*ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.BothDisabled }}</span>
	</div>
</div>